export default __webpack_public_path__ + "static/media/icon7.00109846.png";